import { Routes, RouterModule,CanActivate }  from '@angular/router';
import { Pages } from './pages.component';
import { ModuleWithProviders } from '@angular/core';
import {Schedule} from './schedule/schedule.component';
import {CanActivateTeam} from '../common/services/permission/guard.service';
// noinspection TypeScriptValidateTypes

// export function loadChildren(path) { return System.import(path); };

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: './login/login.module#LoginModule'
  },
  {
    path: 'register',
    loadChildren: './register/register.module#RegisterModule'
  },
  {
    path: 'change-password',
    loadChildren: './ChangePassword/ChangePassword.module#ChangePasswordModule'
  },
  {
    path: 'pages',
    component: Pages,
    children: [
      //{ path: '', redirectTo: 'schedule/treatment-list', pathMatch: 'full' },
      { path: '', redirectTo: 'schedule/mastersche', pathMatch: 'full' },
     // { path: 'dashboard', loadChildren: 'app/pages/dashboard/dashboard.module#DashboardModule', canActivate:[CanActivateTeam] },
       { path: 'schedule', loadChildren: './schedule/schedule.module#ScheduleModule' },
        
      {
        path:'masters',loadChildren:'./masters/masters.module#MastersModule'
      },
      {
        path:'userManager',loadChildren:'./userManager/userManager.module#UserManagerModule'
      },
      {
        path:'report',loadChildren:'./reports/report.module#ReportsModule'
      },
     
      
    ]
  }
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
